import { Image as AntdImage } from "antd";

import type { AvE2EProps } from "../types";
import type { ImageProps as AntdImageProps } from "antd/lib";

export type ImageProps = AntdImageProps & AvE2EProps;

export function CustomImage({ testIdPrefix, ...restProps }: ImageProps) {
  return <AntdImage data-testid={`${testIdPrefix}-image`} {...restProps} />;
}

export const Image = Object.assign(CustomImage, {
  PreviewGroup: AntdImage.PreviewGroup,
});
